import type { Message } from 'types';
import { coreApi } from '.';

export const chatbotService = coreApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getWelcomeMessage: builder.query<{ welcome_message: string }, string | undefined>({
      query: (assistantId) => ({
        url: 'Chatbot/WelcomeMessage',
        method: 'GET',
        params: assistantId === undefined ? {} : { AssistantId: assistantId },
      }),
    }),
    sendMessage: builder.mutation<{ message: string }, { assistantId?: string; message: string; history: Message[] }>({
      query: ({ assistantId, message, history }) => ({
        url: `Chatbot/Message`,
        method: 'POST',
        body: assistantId === undefined ? { message, history } : { assistantId, message, history },
      }),
    }),
  }),
});
export const { useGetWelcomeMessageQuery, useLazyGetWelcomeMessageQuery, useSendMessageMutation } = chatbotService;
